import SpotifyApi from "./SpotifyApi";

const SpotifyInstance = new SpotifyApi();

export default SpotifyInstance;